import { Component, Input } from '@angular/core'

@Component({
  selector: 'mmx-eligibility-benefit-details',
  templateUrl: './eligibility-benefit-details.component.html',
  standalone: false,
})
export class EligibilityBenefitDetailsComponent {
  @Input() benefit: any
}
